import { useAppDispatch, useAppSelector } from '@common/hooks/store';
import styled from '@emotion/styled';
import { engagementApi } from '@features/engagement/api/engagementApi';
import { selectHasEngagementTasks } from '@features/engagement/slice/engagementSelectors';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const StyledChip = styled(Chip)`
  width: 100%;
  justify-content: left;
  border-radius: 4px;

  &.MuiChip-colorError {
    animation: pulse 2s infinite;
  }

  & > .MuiSvgIcon-root {
    margin-left: 8px;
  }

  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
      box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
    }
    70% {
      -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
      box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
      box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
    }
  }
`;

export default function EngagementLink() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const hasTasks = useAppSelector(selectHasEngagementTasks);
  const handleClick = () => {
    navigate('/engagement');
  };

  useEffect(() => {
    dispatch(engagementApi.endpoints.fetchEngagementTasks.initiate());
  }, [ dispatch ]);

  if (hasTasks) {
    return (
      <Box p={1} pb={0}>
        <StyledChip
          icon={<CardGiftcardIcon/>}
          label={<FormattedMessage id="ENGAGEMENT_LINK"/>}
          color="error"
          onClick={handleClick}
          clickable={true}
        />
      </Box>
    );
  }
  return null;
}
